import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { formatTime } from '../utils/formatters.js'

export const useDevLogStore = defineStore('devLog', () => {
    const entries  = ref([])
    const open     = ref(false)
    const filter   = ref('all')   // all | api | event | error
    const snapA    = ref(null)    // { entries, url, time } frozen copy
    const snapB    = ref(null)

    const visible  = computed(() => window.__cortexDev?.())

    function push(type, label, detail = null, status = null) {
        entries.value.unshift({
            id:      crypto.randomUUID(),
            time:    formatTime(),
            ms:      Date.now(),
            type,    // 'req' | 'res' | 'err' | 'evt'
            label,
            detail,  // arbitrary object
            status,  // HTTP status or null
        })
        if (entries.value.length > 200) entries.value.length = 200
    }

    function clear() { entries.value = [] }

    function saveSnap(slot) {
        const snap = {
            entries: entries.value.slice(),
            url: window.location.pathname,
            time: formatTime(),
        }
        if (slot === 'A') snapA.value = snap
        else snapB.value = snap
    }

    return { entries, open, filter, visible, push, clear, snapA, snapB, saveSnap }
})
